import { useState } from 'react';

const ChatListItem = (props) => {
    return (
        <button style={{display: !props.isVisible? "none":""}} className={props.active? "activeChat": ""} onClick={props.clickCallback}>
            <div>
                <span>{props.chatPartner}</span>
                <span>{props.timeStampAsString}</span>
            </div>
            <div>
                <span>{props.trimmedLastMessage}</span>
                <div className={props.unseen === 0 || props.unseen === undefined? "":"unseenMessages"} >
                    <span>{props.unseen === 0 || props.unseen === undefined? "": props.unseen }</span>
                </div>
            </div>
        </button>
    );
}

export {ChatListItem};